import React from "react";
import { render } from "react-dom";

import App from "./containers/App";

import "./index.css";

const root = document.getElementById("root");

render(<App />, root);
